import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "./assets/styles/index.scss";
import "./assets/styles/account.scss";
import "animate.css";

import FormBuilder from "lucien-form-builder";
Vue.use(FormBuilder);

import { Simplert } from "vue2-simplert-plugin";
import "vue2-simplert-plugin/dist/vue2-simplert-plugin.min.css";
Vue.use(Simplert);

Vue.config.productionTip = false;

import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
Vue.use(VueGoodTablePlugin);

import CopyDeck from "@/json/copydeck.js";

Vue.mixin({
  methods: {
    $CD(key, lang) {
      return CopyDeck.get(key, lang);
    },
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
